// extracted by mini-css-extract-plugin
export default {"bucketWrapper":"styles_bucketWrapper__MBnnx","bucket":"styles_bucket__wBn8S","item":"styles_item__UuOGD","content":"styles_content__8N2fN"};